import { LeadStatus } from '@maximizer/core/shared/domain';
import { AbEntryType, EmailEntryType } from './outlook/outlook.email';

export interface EntrySearchResult {
  id: string;
  displayName: string;
  emailAddress: string;
  type: EmailEntryType;
  abentryType?: AbEntryType;
  parentKey?: string;
  companyName: string;
  jobTitle?: string;
  phoneNumber?: string;
  lastContactDate?: string;
  lastModifiedDate?: string;
  leadStatus?: LeadStatus;
}

export type EntrySearchGroupType =
  | 'individuals'
  | 'contacts'
  | 'companies'
  | 'leads';

export interface EntrySearchResultGroup {
  type: EntrySearchGroupType;
  results: EntrySearchResult[];
}

export const ENTRY_SEARCH_GROUP_ORDER: EntrySearchGroupType[] = [
  'individuals',
  'contacts',
  'companies',
  'leads',
];
